// Calculates days remaining between now and a given date
export const daysRemaining = (date: Date) => {
  const today = new Date()
  const oneDay = 1000 * 60 * 60 * 24
  return Math.ceil((date.getTime() - today.getTime()) / oneDay)
}
